export enum LoanStatus {
  TO_REDEEM,
  TO_REPAY,
  ONLY_REPAY,
  TO_BORROW,
}
